import { render, staticRenderFns } from "./QuizTest.vue?vue&type=template&id=56346adf&"
import script from "./QuizTest.vue?vue&type=script&lang=js&"
export * from "./QuizTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports